module.exports = __webpack_public_path__ + "img/tidak_dicover.1d0af874.svg";